import { ComboField } from '@components/Fields/ComboField';
import { Fieldset } from '@components/Fields/Fieldset';
import { TelefoneField } from '@components/Fields/TelefoneField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { VerticalGrid } from '@components/VerticalGrid';
import { useComboBoolean } from '@hooks/useComboBoolean';
import { IForm } from '@hooks/useForm';
import PhoneIcon from '@material-ui/icons/Phone';
import { IComboContratoOperadora } from '@model/ContratoOperadora';
import ILinha from '@model/Linha';
import React from 'react';

export type LinhaEditarFormularioProps = {
    form: IForm<Partial<ILinha>>
    contratoOperadoraCombo: IComboContratoOperadora
}

export function LinhaEditarFormulario ({ form, contratoOperadoraCombo }: LinhaEditarFormularioProps) {
    const { fields } = form;

    const linhaEmpresaCombo = useComboBoolean();
    const vozIlimitadaCombo = useComboBoolean();

    return (
        <VerticalGrid>
            <Fieldset
                icon={<PhoneIcon />}
                title="Parâmetros"
                hasMarginTop={false}
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={3}>
                        <TelefoneField 
                            maskType="cel"
                            field={fields.numeroSemMascara}
                            label="Número"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <ComboField
                            field={fields.contratoOperadoraId}
                            label="Contrato Operadora"
                            required
                        >
                            {
                                contratoOperadoraCombo.createOptions()
                            }
                        </ComboField>
                    </GridItem>

                    <GridItem xs={3}>
                        <ComboField
                            field={fields.linhaEmpresa}
                            label="Linha Empresa"
                            required
                        >
                            {
                                linhaEmpresaCombo.createOptions()
                            }
                        </ComboField>
                    </GridItem>

                    <GridItem xs={3}>
                        <ComboField
                            field={fields.vozIlimitada}
                            label="Voz Ilimitada"
                            required
                        >
                            {
                                vozIlimitadaCombo.createOptions()
                            }
                        </ComboField>
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>
       </VerticalGrid>
    )
}